module.exports = __webpack_public_path__ + "static/media/profile.990bf6c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Avatar/profile.svg
// module id = 1390
// module chunks = 0